import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { AfterViewInit, Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import moment from 'moment';
import { debounceTime } from 'rxjs/operators';
import { IGetEmpresa } from 'src/app/services/EmpresaService/empresa.model';
import { EmpresaService } from 'src/app/services/EmpresaService/empresa.service';
import { AppExportBase64 } from 'src/app/services/ExportBase64/exportBase64.service';
import { IGetReportBase64 } from 'src/app/services/ReportService/report.model';
import { ReportService } from 'src/app/services/ReportService/report.service';
import Swal from 'sweetalert2';

import { ITabelaEmpresa } from './listagem-empresa.model';
import {
  formatarCpfCnpj,
  formatarTelefone
} from 'src/app/core/utils/utilities';
import { SwalAlertService } from 'src/app/services/SwalAlertService/swalAlert.service';
import { ModalVincularCavaloCarretaComponent } from '../modal-vincular-cavalo-carreta/modal-vincular-cavalo-carreta.component';
import {
  ICreateTermoUsoVersao,
  IGetLastTermoVersaoByTipoRequest,
  IGetLastTermoVersaoByTipoResult
} from 'src/app/services/TermoUso/termoUso.model';
import { TermoUsoService } from 'src/app/services/TermoUso/termo-uso.service';

type IOptions = {
  name: string;
  value: string | number;
};
@Component({
  selector: 'app-listagem-empresa',
  templateUrl: './listagem-empresa.component.html',
  styleUrl: './listagem-empresa.component.scss'
})
export class ListagemEmpresaComponent implements OnInit, AfterViewInit {
  isLoading: boolean = false;
  numeroPagina: number = 0;
  form = this._inicializarFormulario();
  tableData: ITabelaEmpresa[] | Array<any> = [];
  pesquisaParams = {
    NM_FNTS_EPSA: '',
    PAGE_NUMBER: 1,
    PAGE_SIZE: 8
  };
  maxPages: number = 1;
  expandirCardsMobile: boolean = true;

  servicoOptions: IOptions[] = [
    {
      name: '',
      value: ''
    }
  ];

  tableColumns = [
    { header: 'Código', key: 'codigo', type: 'text' },
    { header: 'Empresa', key: 'empresa', type: 'text' },
    { header: 'CNPJ', key: 'cnpj', type: 'text' },
    { header: 'E-mail', key: 'email', type: 'text' },
    { header: 'Telefone', key: 'telefone', type: 'text' },
    { header: 'Tel. Financeiro', key: 'financeiro', type: 'text' },
    {
      header: 'Faturado',
      key: 'ativo',
      type: 'switch',
      action: (item: any) => this.swalFaturarEmpresa(item, false)
    },
    {
      header: 'Suspender',
      key: 'check',
      type: 'checkbox',
      action: (item: any) => this.swalFaturarEmpresa(item, true)
    },
    {
      header: 'Ações',
      key: 'actions',
      type: 'buttons',
      buttons: [
        {
          label: 'Visualizar',
          img: 'assets/eye-icon.png',
          action: (item: any) => this.navegarOrdemServico(item),
          condition: (item: any) => item.situacao
        },
        {
          label: 'Vincular Cavalo ou Carreta',
          img: 'assets/bx-link.png',
          action: (item: any) => this.vincularCavaloOuCarreta(item)
        }
      ]
    }
  ];
  selectedItem: any;

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private empresaService: EmpresaService,
    private reportService: ReportService,
    private appExportBase64: AppExportBase64,
    public swalAlert: SwalAlertService,
    public dialog: MatDialog,
    public termoUsoService: TermoUsoService
  ) {}

  private _inicializarFormulario() {
    const form = this.fb.group({
      NM_FNTS_EPSA: this.fb.control('', {
        nonNullable: true,
        validators: [Validators.required]
      })
    });
    return form;
  }

  ngOnInit(): void {
    this.getEmpresas();
  }

  ngAfterViewInit(): void {
    this.form.valueChanges.pipe(debounceTime(300)).subscribe(() => {
      this.getEmpresas();
    });
  }

  mudarPagina(pagina: number) {
    this.pesquisaParams.PAGE_NUMBER = pagina;
    this.numeroPagina = pagina;
    this.getEmpresas(
      this.pesquisaParams.NM_FNTS_EPSA,
      this.pesquisaParams.PAGE_NUMBER,
      this.pesquisaParams.PAGE_SIZE
    );
  }

  formatarCampos(campo: string | number | Date): string {
    return campo === null || campo === '' ? 'Não Informado' : String(campo);
  }

  getHours(date: Date) {
    if (date !== null) {
      return moment(date).format('HH:mm');
    }
    return '******';
  }

  getDate(date: Date) {
    if (date !== null) {
      return moment(date).format('DD/MM/YYYY');
    }
    return '******';
  }

  selecionarFuncionario(item: any) {
    this.selectedItem = item;
  }

  getEmpresas(nomeEmpresa?: string, pageNumber?: number, pageSize?: number) {
    this.isLoading = true;
    nomeEmpresa = String(this.form.controls.NM_FNTS_EPSA.value);

    this.empresaService
      .GetEmpresaByFilter(nomeEmpresa, pageNumber, pageSize)
      .subscribe({
        next: (response: IGetEmpresa) => {
          this.isLoading = false;
          this.tableData = response.ITEMS.map(item => {
            return {
              codigo: item.PK_EPSA ?? 0,
              email: item.TX_MAIL_EPSA,
              empresa: item.NM_FNTS_EPSA,
              cnpj: formatarCpfCnpj(String(item.TX_CNPJ_EPSA), 'cnpj'),
              telefone: formatarTelefone(String(item.NU_TELE_EPSA)),
              financeiro: formatarTelefone(String(item.NU_TELE_OPRC_EPSA)),
              ativo: item.FL_FTRD_EPSA == 3 ? true : false,
              check: item.FL_FTRD_EPSA == 4 ? true : false,
              situacao: item.FL_FTRD_EPSA
            };
          });
          this.maxPages = response.TOTAL_PAGES;
        },
        error: (_error: any) => {
          this.isLoading = false;
        }
      });
  }

  swalFaturarEmpresa(item: any, isSuspender: boolean) {
    let actionString = '';
    if (isSuspender) {
      actionString =
        item.situacao == 4
          ? 'retomar faturamento para'
          : 'suspender faturamento para';
    } else {
      actionString = item.situacao == 3 ? 'desfaturar' : 'faturar';
    }

    Swal.fire({
      title: 'Faturamento de Empresa',
      text: `Deseja realmente ${actionString} esta empresa?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: 'green',
      cancelButtonColor: 'red',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não'
    }).then(result => {
      if (result.isConfirmed) {
        this.faturarEmpresa(item, isSuspender);
      } else if (result.isDenied || result.isDismissed) {
        this.getEmpresas(
          this.pesquisaParams.NM_FNTS_EPSA,
          this.pesquisaParams.PAGE_NUMBER,
          this.pesquisaParams.PAGE_SIZE
        );
        return;
      }
    });
  }

  faturarEmpresa(item: any, isSuspender: boolean) {
    let statusEmpresa: number;
    this.isLoading = true;
    let actionString = '';
    if (isSuspender) {
      statusEmpresa = item.situacao == 4 ? 3 : 4;
      actionString =
        item.situacao == 4 ? 'Faturamento retomado' : 'Faturamento suspenso';
    } else {
      statusEmpresa = item.situacao == 0 || item.situacao == 4 ? 3 : 0;
      actionString = item.situacao == 3 ? 'Desfaturamento' : 'Faturamento';
    }

    this.empresaService.PatchEmpresa(item.codigo, statusEmpresa).subscribe(
      response => {
        this.isLoading = false;
        this.swalAlert.showAlert(
          'Sucesso!',
          `${actionString} com sucesso.`,
          'success',
          true,
          false,
          undefined,
          () => {
            this.getEmpresas(
              this.pesquisaParams.NM_FNTS_EPSA,
              this.pesquisaParams.PAGE_NUMBER,
              this.pesquisaParams.PAGE_SIZE
            );
          }
        );
      },
      error => {
        this.isLoading = false;
      }
    );
  }

  navegarOrdemServico(item: any): void {
    const queryParams = {
      PK_EPSA: item.codigo
    };
    this.router.navigate(['/listagem/ordem-servico'], { queryParams });
  }

  exportarExcel() {
    this.isLoading = true;

    this.reportService.GetEmpresa().subscribe({
      next: (response: IGetReportBase64) => {
        this.appExportBase64.downloadExcel(
          response.ReportBase64,
          'lista-empresas'
        );
        this.isLoading = false;
      },
      error: _error => {
        this.isLoading = false;
      }
    });
  }

  vincularCavaloOuCarreta(item: any): void {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.width = '680px';
    dialogConfig.disableClose = true;
    dialogConfig.data = {
      FK_EPSA: item.codigo
    };

    const dialogRef = this.dialog.open(
      ModalVincularCavaloCarretaComponent,
      dialogConfig
    );
  }

  uploadArquivo(file: any) {
    this.isLoading = true;

    const body: ICreateTermoUsoVersao = {
      file: file,
      tipoTermoUso: 1,
      isEpsa: true
    };

    this.termoUsoService.CreateTermoUsoVersao(body).subscribe({
      next: response => {},
      error: err => {},
      complete: () => {
        this.isLoading = false;
      }
    });
  }

  downloadArquivo() {
    this.isLoading = true;

    const body: IGetLastTermoVersaoByTipoRequest = {
      TipoTermo: 1,
      IsEpsa: true
    };

    this.termoUsoService.GetLastTermoVersaoByTipo(body).subscribe({
      next: (response: IGetLastTermoVersaoByTipoResult) => {
        this.appExportBase64.downloadPDF(
          response.File.Base64Content,
          'TermoDeUso_Empresa_V' + response.TermoId
        );

        this.isLoading = false;
      },
      error: _error => {
        this.isLoading = false;
      }
    });
  }
}
